import { labelId } from '../../../../../../features/labels/labels';
﻿import { ALL_METRICS,getMetricColor, formatDeliveredFoodTon, isFedDay, sanitizeSfr } from "../../../constants/constantsAnalytic";

const t = (translate, key, fallback) => {
  const value = typeof translate === "function" ? translate(key) : key;
  return value && value !== key ? value : fallback;
};

const metricTranslationKeyMap = {
  delivered_food: ["delivered_food", "Delivered food"],
  sfr_value: ["average_sfr", "SFR"],
  alarms_count: ["alarms", "Alarms"],
  perdidos_count: ["pellets_lost", "PPA"],
  visitas_count: ["visits", "Visits"],
};

const getMetricLabel = (translate, metricKey, fallback) => {
  const [translationKey, defaultLabel] = metricTranslationKeyMap[metricKey] || [metricKey, fallback || metricKey];
  return t(translate, translationKey, defaultLabel);
};


export const handleLegendClick = (metricKey, setExcludedMetrics, setHoverInfo, setSelectedInfo, setHoverDayInfo) => {
    setExcludedMetrics((prev) => {
      if (prev.includes(metricKey)) {
        return prev.filter((m) => m !== metricKey);
      } else {
        return [...prev, metricKey];
      }
    });
    setHoverInfo(null);
    setSelectedInfo(null);
    setHoverDayInfo(null);
  };


  
  // ================================
  // Renderizar â€œbarrasâ€ radiales por dÃ­a
  // ================================
  export const renderDayBars = ({
    displayedSeries,colors, startAngles,endAngles,PADDING_ANGLE,R_INNER,R_MID_INNER,visibleMetrics,setHoverDayInfo,setHoverInfo,setSelectedInfo,polarToCartesian,translate
  
  }) =>
    displayedSeries?.map((serieObj, iSerie) => {
      const jaulaColor = colors[iSerie] || "#FFFFFF";
      const points = serieObj?.values_summary || [];
      const nPoints = points.length;

      // Ãngulo completo (incluye PADDING)
      const fullStart = startAngles[iSerie];
      const fullEnd   = endAngles[iSerie];
      // Contenedor interior para barras = exclusivo de PADDING
      const innerStart = fullStart + PADDING_ANGLE;
      const innerEnd   = fullEnd   - PADDING_ANGLE;

      return points.map((punto, idx) => {
        const angle = (() => {
          if (nPoints === 1) {
            return (innerStart + innerEnd) / 2;
          }
          const t = idx / (nPoints - 1);
          return innerStart + t * (innerEnd - innerStart);
        })();

        const innerP = polarToCartesian(R_INNER + 2, angle);
        const outerP = polarToCartesian(R_MID_INNER - 4, angle);

        const allValues = visibleMetrics.map((m) => {
          const rawValue = m.key === "sfr_value" ? sanitizeSfr(punto.value) : punto.value[m.key];
          const display =
            m.key === "delivered_food"
              ? formatDeliveredFoodTon(rawValue)
              : (rawValue == null ? "-" : rawValue); // null = SFR irrecuperable
          return { label: getMetricLabel(translate, m.key, m.label), value: display, color: m.color };
        });

        return (
          <line
            key={`daybar-${iSerie}-${idx}`}
            x1={innerP.x}
            y1={innerP.y}
            x2={outerP.x}
            y2={outerP.y}
            stroke={jaulaColor}
            strokeWidth="10"
            opacity="0.3"
            onMouseEnter={() => {
              setHoverDayInfo({
                day: punto.day,
                seriesName: serieObj.name,
                allValues,
              });
              setHoverInfo(null);
              setSelectedInfo(null);
            }}
            onMouseLeave={() => setHoverDayInfo(null)}
          />
        );
      });
    });

  // ================================
  // Renderizar burbujas de mÃ©tricas
  // ================================
export const renderBubbleSeries = ({
     displayedSeries, startAngles,endAngles,PADDING_ANGLE,visibleMetrics,setHoverDayInfo,setHoverInfo,setSelectedInfo,metricMaxima,computeMetricRadius,hoverInfo,selectedInfo,
     mapValueToBubbleRadius,polarToCartesian
     ,translate
  }) =>
    displayedSeries?.map((serieObj, iSerie) => {
      const points = serieObj?.values_summary || [];
      const nPoints = points.length;

      // Ãngulo completo (incluye PADDING)
      const fullStart = startAngles[iSerie];
      const fullEnd   = endAngles[iSerie];
      // Contenedor interior para burbujas
      const innerStart = fullStart + PADDING_ANGLE;
      const innerEnd   = fullEnd   - PADDING_ANGLE;

      return points.flatMap((punto, idx) => {
        return visibleMetrics.map((m, mIdx) => {
          const metricKey = m.key;
          const rawValue = metricKey === "sfr_value" ? sanitizeSfr(punto.value) : punto.value[metricKey];
          // âš ï¸ SALTAR burbujas con valor 0 o no numÃ©rico
          if (!rawValue || Number(rawValue) === 0) return [];
          const maxVal = metricMaxima[metricKey] || 1;
          const isDelivered = metricKey === "delivered_food";
          const bubbleRadius = mapValueToBubbleRadius(rawValue, maxVal, isDelivered);

          const angle = (() => {
            if (nPoints === 1) {
              return (innerStart + innerEnd) / 2;
            }
            const t = idx / (nPoints - 1);
            return innerStart + t * (innerEnd - innerStart);
          })();

          const r = computeMetricRadius(mIdx);
          const { x: cx, y: cy } = polarToCartesian(r, angle);

          let opacity = 0.8;
          if (hoverInfo || selectedInfo) {
            const isSameMetricDay =
              (hoverInfo &&
                hoverInfo.metricKey === metricKey &&
                hoverInfo.day === punto.day) ||
              (selectedInfo &&
                selectedInfo.metricKey === metricKey &&
                selectedInfo.day === punto.day);
            opacity = isSameMetricDay ? 1 : 0.2;
          }
          const isExact =
            (hoverInfo &&
              hoverInfo.metricKey === metricKey &&
              hoverInfo.day === punto.day &&
              hoverInfo.seriesName === serieObj.name) ||
            (selectedInfo &&
              selectedInfo.metricKey === metricKey &&
              selectedInfo.day === punto.day &&
              selectedInfo.seriesName === serieObj.name);
          const strokeColor = isExact ? "#FFFFFF" : "#46465C";
          const strokeWidth = isExact ? 2 : 0.5;

          const bubble = (
            <circle
              key={`bubble-${iSerie}-${idx}-${metricKey}`}
              cx={cx}
              cy={cy}
              r={bubbleRadius}
              // fill={METRIC_COLORS[metricKey]}
              fill={m.color}
              stroke={strokeColor}
              strokeWidth={strokeWidth}
              opacity={opacity}
              style={{ cursor: "pointer" }}
              onMouseEnter={() => {
                setHoverInfo({
                  day: punto.day,
                  seriesName: serieObj.name,
                  metricKey,
                  metricLabel: getMetricLabel(translate, m.key, m.label),
                  metricValue: isDelivered
                    ? formatDeliveredFoodTon(rawValue)
                    : rawValue,
                });
                setHoverDayInfo(null);
              }}
              onMouseLeave={() => {
                setHoverInfo(null);
              }}
              onClick={() => {
                if (
                  selectedInfo &&
                  selectedInfo.metricKey === metricKey &&
                  selectedInfo.day === punto.day &&
                  selectedInfo.seriesName === serieObj.name
                ) {
                  setSelectedInfo(null);
                } else {
                  setSelectedInfo({
                    metricKey,
                    day: punto.day,
                    seriesName: serieObj.name,
                  });
                }
                setHoverDayInfo(null);
                setHoverInfo(null);
              }}
            />
          );

          const redDot =
            idx === 0 ? (
              <circle
                key={`start-dot-${iSerie}-${metricKey}`}
                cx={cx}
                cy={cy}
                r={bubbleRadius * 0.4}
                fill="red"
                stroke="none"
              />
            ) : null;

          return [bubble, redDot];
        });
      });
    });

  // ================================
  // Renderizar arcos punteados por mÃ©trica
  // ================================
  export const renderDashedArcs = ({
         displayedSeries, startAngles,endAngles,PADDING_ANGLE,visibleMetrics,computeMetricRadius,polarToCartesian
  }) =>
    displayedSeries?.flatMap((_, iSerie) => {
      // Ãngulo completo (incluye PADDING)
      const fullStart = startAngles[iSerie];
      const fullEnd   = endAngles[iSerie];
      // Contenedor interior para arcos punteados
      const innerStart = fullStart + PADDING_ANGLE;
      const innerEnd   = fullEnd   - PADDING_ANGLE;

      return visibleMetrics.map((_, mIdx) => {
        const radius = computeMetricRadius(mIdx);
        const pStart = polarToCartesian(radius, innerStart);
        const pEnd   = polarToCartesian(radius, innerEnd);
        const largeArcFlag = innerEnd - innerStart <= 180 ? "0" : "1";

        return (
          <path
            key={`dashed-arc-${iSerie}-${mIdx}`}
            d={[
              "M", pStart.x.toFixed(3), pStart.y.toFixed(3),
              "A", radius.toFixed(3), radius.toFixed(3), 0, largeArcFlag, 1,
              pEnd.x.toFixed(3),   pEnd.y.toFixed(3),
            ].join(" ")}
            fill="none"
            stroke="#AAAAAA"
            strokeDasharray="4,3"
            strokeWidth="0.5"
          />
        );
      });
    });


// ================================
// Renderizar arcos exteriores y etiquetas de jaula
// ================================

const getShortCenterName = (name) => {
      if (typeof name !== 'string') return '';
      const parts = name.split('-');
      return parts[parts.length - 1]; // Ãºltimo segmento
};

export const renderOuterArcsAndLabels = ({
        displayedSeries, startAngles,endAngles,colors,R_OUTER,
        describeOuterArc,polarToCartesian,nivelSeleccionado

}) => {
  return displayedSeries?.map((serieObj, iSerie) => {

    // console.log('serieObj',serieObj)



    const startAngle = startAngles[iSerie];
    const endAngle   = endAngles[iSerie];

    const jaulaColor = colors[iSerie] || "rgba(100,100,200,0.6)";
    
    const nombreCompleto = serieObj.name || serieObj.seriesName;
    const nombre = nivelSeleccionado === 'centro' ? nombreCompleto : labelId(nombreCompleto, 'rac', nivelSeleccionado === 'area' ? getShortCenterName(nombreCompleto) : nombreCompleto)
    // const nombre = nombreCompleto//getShortCenterName(nombreCompleto);


    const arcElement = describeOuterArc(startAngle, endAngle, jaulaColor);

    const midAngle = (startAngle + endAngle) / 2;
    const { x: lx, y: ly } = polarToCartesian(R_OUTER + 75, midAngle);
    let textRotate;
    if (midAngle >= 0 && midAngle < 90) {
      textRotate = midAngle;
    } else if (midAngle >= 90 && midAngle < 180) {
      textRotate = midAngle + 180;
    } else if (midAngle >= 180 && midAngle < 270) {
      textRotate = midAngle - 180;
    } else {
      textRotate = midAngle;
    }

    return (
      <g key={`outer-jaula-${iSerie}`}>
        {arcElement}
        <text
          x={lx}
          y={ly}
          fill="#c3c3c3"
          fontSize="1vw"
          fontWeight="600"
          textAnchor="middle"
          alignmentBaseline="middle"
          // transform={`rotate(${textRotate} ${lx} ${ly})`}
          style={{ pointerEvents: "none" }}
        >
          {nombre} 
        </text>
      </g>
    );
  });
};

// ================================
// Renderizar la tabla de valores cuando â€œselectedInfoâ€ existe
// ================================
export const renderSelectedTable = ({
        displayedSeries,selectedInfo,colors,CY,CX,nivelSeleccionado,translate

}) => {
  if (!selectedInfo) return null;

  const { metricKey, day } = selectedInfo;
  const [metricTranslationKey, metricFallback] = metricTranslationKeyMap[metricKey] || [metricKey, metricKey];
  const metricLabel = t(translate, metricTranslationKey, metricFallback);
  const metricColor = ALL_METRICS.find((m) => m.key === metricKey)?.color || metricKey;

  const columns = displayedSeries.map((serieObj, i) => {
    const match = serieObj.values_summary.find((item) => item.day === day);
    let rawValue = match
      ? (metricKey === "sfr_value" ? sanitizeSfr(match.value) : match.value[metricKey])
      : null;
    let display;
    if (rawValue == null) {
      display = "-";
    } else if (metricKey === "delivered_food") {
      display = formatDeliveredFoodTon(rawValue);
    } else {
      display = rawValue;
    }
    const seriesColor = colors[i] || "#FFF";
    const name = serieObj.name || serieObj.seriesName
    const nombre = nivelSeleccionado === 'centro' ? name : labelId(name, 'rac', nivelSeleccionado === 'area' ? getShortCenterName(name) : name)

    return {
      seriesName: name,
      label: nombre,
      display,
      seriesColor,
    };
  });
  
  const lineHeight = 30; // en px o en unidades SVG
  const startY = CY - 60; // punto de partida arriba del CX,CY
  
  return (
       <g>
      {/* DÃ­a */}
      <text
        x={CX}
        y={startY}
        textAnchor="middle"
        fontSize="1vw"
        // fill="#e84e0e"
        fill={ metricColor || "#c3c3c3"}
        fontWeight="700"
      >
        {t(translate, 'day', 'Day')}: {day}
      </text>

      {/* MÃ©trica */}
      <text
        x={CX}
        y={startY + lineHeight}
        textAnchor="middle"
        fontSize="0.9vw"
        fill={ metricColor || "#c3c3c3"}
        fontWeight="600"
      >
        {metricLabel}
      </text>

      {/* Series */}
      {columns.map((col, idx) => (
        <text
          key={col.seriesName}
          x={CX}
          y={startY + (idx + 2) * lineHeight}
          textAnchor="middle"
          fontSize="0.63vw"
          fill={col.seriesColor}
          fontWeight="600"
        >
          {col.label}: {col.display}
        </text>
      ))}
    </g>
    // <div
    //   style={{
    //     position: "absolute",
    //     top: `${CY - 20}vh`,
    //     // left: `${CX - 10}vw`,
    //     transform: "translate(-50%, -50%)",
    //     borderRadius: "0.5vw",
    //     color: "#FFF",
    //     width: "30%",
    //     textAlign: "center",
    //     pointerEvents: "none",
    //   }}
    // >
    //   <div
    //     style={{
    //       fontSize: "1vw",
    //       fontWeight: 600,
    //       color: "#e84e0e",
    //     }}
    //   >
    //     {t(translate, 'day', 'Day')}: {day}
    //   </div>
    //   <div
    //     style={{
    //       fontSize: "0.9vw",
    //       marginBottom: "1vh",
    //       color: METRIC_COLORS[metricKey] || "#FFF",
    //     }}
    //   >
    //     {metricLabel}
    //   </div>
    //   {columns.map((col) => {
    //     console.log('col',col)
    //     return(
    //       <p key={col.seriesName} style={{ marginTop: "-0.5vh" }}>
    //         <span style={{ color: col.seriesColor, fontWeight: 600, fontSize: '0.63vw' }}>
    //           {col.seriesName} : {col.display}
    //         </span>
    //       </p>
    //     )
    //   })}
    // </div>
  );
};



export const renderAggregatesCentral = ({ colors, aggregatedBySeries, nivelSeleccionado, translate }) => {
  // Filtra solo aquellas mÃ©tricas con vsMetrics = true
  const VISIBLE_METRICS = ALL_METRICS.filter((m) => m.vsMetrics);
  const p = "0.25vh"
  return (
    <table
      style={{
        width: "80%",
        borderCollapse: "collapse",
        fontSize: "0.7vw",
        textAlign: "center",
        margin: "1vh 0",
        backgroundColor: "#1e1e1e",
        color: "#e0e0e0",
        borderTopLeftRadius: "1vh",
        borderTopRightRadius: "1vh",
        borderBottomLeftRadius: "1vh",
        borderBottomRightRadius: "1vh"
      }}
    >
      <thead>
        <tr style={{ backgroundColor: "#2b2b2b", fontWeight: 600 }}>
          <th style={{ padding: p, borderTopLeftRadius: "1vh" }}>{t(translate, "name", "Name")}</th>
          {VISIBLE_METRICS.map((metric, idx) => (
            <th
              key={metric.key}
              style={{
                padding: p,
                borderTopRightRadius: idx === VISIBLE_METRICS.length - 1 ? "1vh" : undefined
              }}
            >
              {t(translate, ...(metricTranslationKeyMap[metric.key] || [metric.key, metric.label]))}{metric.unit}
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {aggregatedBySeries?.map((agg, i) => {
          const jaulaColor = colors[i] || "#ffffff";
          const prefix = "JAULA";
          const displayName = agg?.seriesName?.startsWith(prefix)
            ? agg.seriesName.slice(prefix.length)
            : agg.seriesName;
          const trimmedName = displayName?.trim();
          // console.log('agg',agg)
          // const nombreCompleto = serieObj.name || serieObj.seriesName;
          const nombre = nivelSeleccionado === 'centro' ? trimmedName : labelId(agg.seriesName, 'rac', nivelSeleccionado === 'area' ? getShortCenterName(trimmedName) : trimmedName);

          const valTon = formatDeliveredFoodTon(agg.delivered_food, { withUnit: false });
          const alarms = agg.alarms_count;
          const perdidas = agg.perdidos_count //|| agg.perdidos_cout;
          const visitas = agg.visitas_count //|| agg.visitas_cout; 
          const sfr = agg.sfr_value.toFixed(2);

          const isLast = i === aggregatedBySeries.length - 1;

          return (
            <tr key={`row-${i}`}>
              <td style={{
                padding: p,
                color: jaulaColor,
                fontWeight: 600,
                borderBottomLeftRadius: isLast ? "0.5vh" : undefined
              }}>
               {nombre}
              {/* {getShortCenterName(trimmedName)} */}
              </td>
              <td style={{ padding: p, color: getMetricColor("delivered_food") }}>
                {valTon} ton
              </td>
              <td style={{ padding: p, color: getMetricColor("sfr_value") }}>
                {sfr}%
              </td>
              <td style={{ padding: p, color: getMetricColor("alarms_count") }}>
                {alarms}
              </td>
              <td style={{ padding: p, color: getMetricColor("perdidos_count") }}>
                {perdidas}
              </td>
              <td style={{
                padding: p,
                color: getMetricColor("visitas_count"),
                borderBottomRightRadius: isLast ? "0.5vh" : undefined
              }}>
                {visitas}
              </td>
            </tr>
          );
        })}
      </tbody>
    </table>
  );
};



export function transformCenterData(versus) {
  if (!Array.isArray(versus)) return [];

  const centerMap = {};

  versus.forEach(center => {
    const centerName = center.name;
    const cages = center.analytic_data;

    if (!centerMap[centerName]) {
      centerMap[centerName] = {};
    }

    for (const cageId in cages) {
      const cageData = cages[cageId];
      const summaries = cageData.values_summary || [];

      summaries.forEach(({ day, value }) => {
        if (!centerMap[centerName][day]) {
          centerMap[centerName][day] = {
            delivered_food: 0,
            alarms_count: 0,
            perdidos_count: 0,
            visitas_count: 0,
            sfrSum: 0,
            sfrCount: 0,
            otherValues: { ...value }, // solo para mantener tasa_units, etc si lo necesitas
          };
        }

        const entry = centerMap[centerName][day];

        entry.delivered_food += Number(value.delivered_food || 0);
        entry.alarms_count += Number(value.alarms_count || 0);
        entry.perdidos_count += Number((value.perdidos_count )|| 0);
        entry.visitas_count += Number((value.visitas_count  )|| 0);

        // SFR promedio: solo días alimentados (excluye ayunos) y con SFR saneado (>1000% recalculado/descartado)
        const sfr = sanitizeSfr(value);
        if (isFedDay(value) && Number.isFinite(sfr)) { // null (SFR irrecuperable) se ignora
          entry.sfrSum += sfr;
          entry.sfrCount += 1;
        }
      });
    }
  });

  // Convertimos a arreglo final
  return Object.entries(centerMap).map(([centerName, dayMap]) => {
    const values_summary = Object.entries(dayMap).map(([day, data]) => ({
      day,
      value: {
        delivered_food: data.delivered_food,
        alarms_count: data.alarms_count,
        perdidos_count: data.perdidos_count, //|| data.perdidos_cout,
        visitas_count: data.visitas_count, //|| data.visitas_cout,
        sfr_value: data.sfrCount > 0 ? data.sfrSum / data.sfrCount : 0,
        // conservar tasa_units o cualquier otra metadato si se necesita
        ...("tasa_units" in data.otherValues ? { tasa_units: data.otherValues.tasa_units } : {}),
        ...("alarms_threshold" in data.otherValues ? { alarms_threshold: data.otherValues.alarms_threshold } : {}),
        ...("fasts_count" in data.otherValues ? { fasts_count: data.otherValues.fasts_count } : {}),
        ...("alarms_by_ton" in data.otherValues ? { alarms_by_ton: data.otherValues.alarms_by_ton } : {}),
      }
    }));

    return {
      seriesName: centerName,
      values_summary,
    };
  });
}

